module.exports = __webpack_public_path__ + "images/Picture.50a78f2f218cc2e5b07a828c26abcfc1.svg";